export default __webpack_public_path__ + "static/media/filter-icon.0b2c556c.svg";